import { Injectable } from '@angular/core';
import { HttpLink } from 'apollo-angular-link-http';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import {InMemoryCache} from 'apollo-cache-inmemory';
import { Apollo } from 'apollo-angular';
import { ApolloClientOptions } from 'apollo-client';

export interface ApiUrls{
  col: string;
  rep?: string;
  bi?: string;
  it?: string;
}

@Injectable()
export class ApolloHelperService {
  defaultOptions:any = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
  
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  };

  constructor(private httpLink: HttpLink, private apollo: Apollo) { }

  createApolloInova(urls:ApiUrls, token:string, errorLink:ApolloLink|null=null){
    this.apollo.createDefault(this.getApolloOptions(urls.col,token,errorLink));
    if(urls.bi){
      this.apollo.createNamed('bi',this.getApolloOptions(urls.bi,token,errorLink));
    }
    if(urls.rep){
      this.apollo.createNamed('rep',this.getApolloOptions(urls.rep,token,errorLink));
    }
    if(urls.it){
      this.apollo.createNamed('it',this.getApolloOptions(urls.it,token,errorLink));
    }
  }



  createNamed(name:string, url:string, token:string, errorLink:ApolloLink|null){
    this.apollo.createNamed(name,this.getApolloOptions(url,token,errorLink));
  }

  private getApolloOptions(uri:string, token:string, errorLink:ApolloLink|null):ApolloClientOptions<any>{
    const auth = setContext((operation, context) => ({
      headers: {
        Authorization: `${token}`
      },
    }));
    const links=[auth]
    if(errorLink){
      links.push(errorLink)
    }
    links.push(this.httpLink.create({ uri }))
    return {
      link: ApolloLink.from(links),
      cache: new InMemoryCache({addTypename: false}),
      defaultOptions: this.defaultOptions,
    };
  }

}